import crudActions from '@/store/crudActions'

const actions = crudActions('category-subjects')

export default {
  ...actions,
}
